<template>
    <transition name="slide-fade" appear>
  <div class="form-group col-sm-4" v-if="!isHidden">
    <div class="items-container"
        :class="[this.iconClass, {'enabled-container' : showClickable}, {'color-gray' : !showClickable}]"
        @click="clickedOnButton">
      <div class="button-text-background">
        <div class="button-text-container">
          <span class="button-text">{{ $t(this.text) }}</span>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
  import {loadPage} from '@/helpers/routing'
  export default {
    name: 'homepageGridButton',
    props: {
      iconClass: {
        type: String,
        required: true
      },
      text: {
        type: String,
        default: ''
      },
      route: {
        type: String,
        default: ''
      },
      idService: {
        type: Number,
        default: 0
      },
      isHidden: {
        type: Boolean,
        default: false
      },
      enabled: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      showClickable () {
        return this.enabled
      }
    },
    methods: {
      clickedOnButton () {
        if (this.showClickable) {
          this.$bus.emit('printHomepageNavbar', false)
          this.$bus.emit('isOnHomepage', false)
          if (this.route) {
            let that = this
            if (this.idService !== 0) {
              this.$engine.user.changeService(this.$engine.services.getServiceById(this.idService))
              this.$engine.user.currentService.id = this.idService
            }
            loadPage(that, {url: this.route})
          }
        }
      },
      getImage () {
        var contxt = require.context('../../assets/static/images/', true, /\.(?:png|jpg)$/)
        return contxt('./' + this.iconName)
      }
    }
  }
</script>

<style scoped>
  .items-container {
    display: flex;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    height: 30vh;
  }
  .enabled-container:hover {
    cursor: pointer;
    box-shadow: rgba(0,0,0,0.3) 0 0 10px;
  }
  .button-text-background {
    display: flex;
    text-align: center;
    background-color: #ffffffbb;
    width: 100%;
    margin-top: auto;
    margin-bottom: 3.5%;
  }
  .button-text-container {
    display: flex;
      width: 100%;
      margin-top: auto;
      margin-bottom: auto;
  }
  .button-text {
    display: block;
    text-align: center;
    font-weight: 500;
    font-size: 1.5em;
    margin-left: auto;
    margin-right: auto;
  }

  /* Small devices (landscape phones, 544px and up) */
  @media (min-width: 544px and max-width:991px) {
    .button-text-container {
      font-size: 0.9em;
    }
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 1431px) {
    .button-text {
      font-size: 2.2rem;
    }
  }

  /* TLV 10/09/2020
  * Classes pour prélever les images de la page d'accueil (nouvelle charte graphique) */
  .icon-homepage-button-history {
    background-image: url('./../../assets/static/images/homepage/send_a_payment.png');
  }

  .icon-homepage-button-propose-loan {
    background-image: url('./../../assets/static/images/homepage/proposer_modular_loan.png');
  }

  .icon-homepage-button-request-document {
    background-image: url('./../../assets/static/images/homepage/request_a_document.png');
  }

  .icon-homepage-button-request-loan {
    background-image: url('./../../assets/static/images/homepage/ask_for_modular_loan.png');
  }

  .icon-homepage-button-request-payment {
    background-image: url('./../../assets/static/images/homepage/request_to_pay.png');
  }

  .icon-homepage-button-request-payment-list {
    background-image: url('./../../assets/static/images/homepage/request_a_document.png');
  }

  .icon-homepage-button-send-document {
    background-image: url('./../../assets/static/images/homepage/send_a_document.png');
  }

  .icon-homepage-button-send-payment {
    background-image: url('./../../assets/static/images/homepage/send_a_payment.png');
  }
</style>



// WEBPACK FOOTER //
// homepageGridButton.vue?6bbb2708